'use client';

import { Button, Padding, Typography } from '@musinsa/mds';

interface Props {
  className?: string;
  title?: string;
  retryButtonText?: string;
  onRetry?: () => void;
}

export const ErrorAndRetry = ({
  className,
  title = '서비스 접속이 원활하지 않습니다.',
  retryButtonText = '새로고침',
  onRetry,
}: Props) => {
  const handleRetry = () => {
    if (typeof onRetry === 'function') {
      onRetry();
      return;
    }

    window.location.reload();
  };

  return (
    <div className={className}>
      <Padding x="4" y="10">
        <div className="flex flex-col gap-12 items-center justify-center">
          <div className="flex items-center w-full">
            <Typography variant="body13pxMed">{title}</Typography>
          </div>

          <Button
            variant="tertiary"
            size="24"
            onClick={handleRetry}
            className="border border-gray-300"
          >
            <Typography size="13" weight="medium" colorScheme="black">
              {retryButtonText}
            </Typography>
          </Button>
        </div>
      </Padding>
    </div>
  );
};
